<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备库存管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>

        <el-form-item label="是否大型设备">
          <el-select v-model="formInline.is_big_device" clearable placeholder="请选择是否大型设备">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="device_name" label="设备名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="device_category_desc" label="设备分类" width="120">
        </custom-table-column>
        <custom-table-column label="是否大型设备" prop="is_big_device" width="150" label-class-name="iss"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structureFull" label="所属组织结构" width="160">
        </custom-table-column>
        <custom-table-column prop="device_model" label="型号" width="150">
        </custom-table-column>
        <custom-table-column prop="specification" label="规格" width="160">
        </custom-table-column>
        <!-- <custom-table-column prop="country_code" label="国别码" width="160">
        </custom-table-column>
        <custom-table-column prop="device_price" label="单价" width="160">
        </custom-table-column> -->
        <custom-table-column prop="device_qty" label="库存数量" width="160">
        </custom-table-column>
        <custom-table-column prop="total_device_amount" label="设备总金额" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">查看详情</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="946px">
      <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item label="设备编号">
            <el-input v-model="formInline1.serial_no" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item :label="`${$store.state.themeTitle}室`">
            <el-select v-model="formInline1.training_room_id" clearable filterable placeholder="请选择">
              <el-option v-for="itemm in $store.state.trainRooms" :key="itemm.id" :label="itemm.training_name"
                :value="itemm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery1">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding: 8px 0;">
        <el-tag v-if="formInline1.device_name">设备名称：{{ formInline1.device_name }}</el-tag>
        <el-tag v-if="formInline1.structure_1">所属组织结构：{{ formInline1.structure_1 }}{{ formInline1.structure_2
        }}</el-tag>
        <el-tag v-if="formInline1.device_model">型号：{{ formInline1.device_model }}</el-tag>
        <el-tag v-if="formInline1.specification">规格：{{ formInline1.specification }}</el-tag>
      </div>
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="serial_no" label="设备编号" width="150">
          </custom-table-column>
          <!-- <custom-table-column prop="" label="所属组织结构" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
            </template>
          </custom-table-column> -->
          <!-- <custom-table-column prop="device_category" label="分类号" width="160">
            <template slot-scope="scope" v-if="scope.row.device">
              <span>{{ scope.row.device.device_category }}</span>
            </template>
          </custom-table-column> -->

          <custom-table-column prop="device_category_desc" label="设备分类" width="160">
            <template slot-scope="scope" v-if="scope.row.device">
              <span>{{ scope.row.device.device_category_desc }}</span>
            </template>
          </custom-table-column>
          <custom-table-column prop="status_desc" label="现状" width="100">
          </custom-table-column>
          <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" width="160">
            <template slot-scope="scope" v-if="scope.row.training_room">
              <span>{{ scope.row.training_room.training_name }}</span>
            </template>
          </custom-table-column>
          <custom-table-column prop="country_code" label="国别码" width="160">
            <template slot-scope="scope" v-if="scope.row.device">
              <span>{{ scope.row.device.country_code }}</span>
            </template>
          </custom-table-column>
          <custom-table-column prop="device_price" label="单价" width="160">
            <!-- <template slot-scope="scope" v-if="scope.row.device">
              <span>{{ scope.row.device.device_price }}</span>
            </template> -->
          </custom-table-column>
          <custom-table-column prop="purchase_date" label="购置日期" width="160">
          </custom-table-column>
          <custom-table-column prop="source_desc" label="来源" width="100">
          </custom-table-column>
          <custom-table-column prop="type_desc" label="使用方向" width="120">
          </custom-table-column>
          <!-- <custom-table-column prop="" label="存放地址" width="120">
          </custom-table-column>
          <custom-table-column prop="" label="保管人员" width="120">
          </custom-table-column> -->
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <!-- <el-button @click="handleDelet1(scope.row.id)" type="text" size="small">删除</el-button> -->
              <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">查看详情</el-button>
              <el-button @click="handleEdit(scope.row, ['device', 'training_room'])" type="text"
                size="small">编辑</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="设备编号" prop="serial_no">
          <el-input v-model="ruleForm.serial_no" placeholder="请输入" clearable style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="itemm in $store.state.trainRooms" :key="itemm.id" :label="itemm.training_name"
              :value="itemm.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备来源" prop="source">
          <el-select v-model="ruleForm.source" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.eqSource" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现状" prop="status">
          <el-select v-model="ruleForm.status" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.xz" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用方向" prop="type">
          <el-select v-model="ruleForm.type" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.syfx" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购置日期" prop="purchase_date">
          <el-date-picker type="date" placeholder="请选择" clearable value-format="yyyy-MM-dd"
            v-model="ruleForm.purchase_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="入库详情" :visible.sync="detailInnerDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
        <template v-if="rowObj.device">
          <el-descriptions-item>
            <template slot="label">设备名称 </template> {{ rowObj.device.device_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">设备分类 </template> {{ rowObj.device.device_category_desc }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">是否大型设备</template> {{ rowObj.device.is_big_device == 1 ? '是' : '否' }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">所属组织结构 </template> {{ rowObj.device.structure_1 }}{{ rowObj.device.structure_2 }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">型号 </template> {{ rowObj.device.device_model }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">规格 </template> {{ rowObj.device.specification }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">国别码 </template> {{ rowObj.device.country_code }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">单价 </template> {{ rowObj.device.device_price }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">库存数量 </template> {{ rowObj.device.device_qty }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">购置日期 </template> {{ rowObj.purchase_date }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">供应商 </template> {{ rowObj.device.supplier }}
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">维修记录</p>
      <custom-table :data="rowObj.repair" border style="width: 100%">
        <custom-table-column prop="date" label="日期">
        </custom-table-column>
        <custom-table-column prop="repair_price" label="维修价格">
        </custom-table-column>
        <custom-table-column prop="machine_failure" label="故障原因">
        </custom-table-column>
      </custom-table>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">维护记录</p>
      <custom-table :data="rowObj.maintenance" border style="width: 100%">
        <custom-table-column prop="date" label="日期">
        </custom-table-column>
        <custom-table-column prop="status_desc" label="状态">
        </custom-table-column>
        <custom-table-column prop="desc" label="维护说明">
        </custom-table-column>
      </custom-table>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">借出记录</p>
      <custom-table :data="rowObj.borrow" border style="width: 100%">
        <custom-table-column prop="borrow_date" label="借出日期">
        </custom-table-column>
        <custom-table-column prop="return_date" label="归还日期">
        </custom-table-column>
        <custom-table-column prop="username" label="申请人">
        </custom-table-column>
      </custom-table>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData"></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinFormatter, mixinPrint],
  data() {
    return {
      formInline: {
        is_big_device: '',
        device_name: '',
        structure_1: '',
        structure_2: '',
      },
      formInline1: {
      },
      detailDialogVisible: false,
      detailInnerDialogVisible: false,
      levell: [1, 2],
      organLabel: '',
      eqs: [],
      rowObj: {},
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      tableData1: [],
      total1: 0,
      listArr: [],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        serial_no: [{ required: true, message: '请输入', trigger: 'blur' }],
        source: [{ required: true, message: `请选择`, trigger: 'change' }],
        type: [{ required: true, message: `请选择`, trigger: 'change' }],
        status: [{ required: true, message: `请选择`, trigger: 'change' }],
      },
      rules1: {},
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
    this.$store.dispatch('getTarinMent', { isEmpty: true });
  },
  methods: {
    handleSet() {
      this.centerDialogVisible = true;
    },
    handlePrint() {
      this.$message({
        type: 'info',
        center: true,
        message: '打印中...',
      })
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data.map(item => ({
          ...item,
          structureFull: item.structure_1 + (item.structure_2 ? item.structure_2 : ''),
        }));;
        this.total = res.data.total;
      }
    },

    async getList1() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/individual/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },

    async detailMethod(row, type = "view") {
      let res = await this.$api.instance.interfaceServer(`api/new_device/individual/detail/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        this.rowObj = res.data;
        this.detailInnerDialogVisible = true;
      }
    },
    handleDetailClick(row) {
      // this.rowObj = row;
      this.detailDialogVisible = true;
      this.formInline1.device_id = row.id;
      this.formInline1.structure_1 = row.structure_1
      this.formInline1.structure_2 = row.structure_2
      this.formInline1.device_name = row.device_name
      this.formInline1.device_model = row.device_model
      this.formInline1.specification = row.specification
      this.tableData1 = []
      this.handleQuery1()
    }, handleQuery() {
      this.beforeQuery1();
      this.$refs.pageChild.page = 1;
      this.getList();
    },

    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/new_device/individual/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },

    clearState() {
      this.resetForm('ruleForm')
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.centerDialogVisible = false;
      this.handleQuery1();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
